import { useState } from "react";

import {
  useDeleteWorkspace,
  useUpdateWorkspace,
  useGetWorkspaces,
  useWorkspaces,
  useSetDefaultWorkspace,
} from "@/queries";
import { Workspace } from "@/types/workspaces";

export const useWorkspaceOperations = ({
  organizationId,
  search = "",
  page = 1,
  perPage = 20,
}: {
  organizationId?: number;
  search?: string;
  page?: number;
  perPage?: number;
}) => {
  const { data: workspaces, isLoading: isLoadingWorkspaces } = useGetWorkspaces({
    perPage,
    page,
    organizationId,
    search: search || undefined,
  });
  const { data: accessibleWorkspaces } = useWorkspaces();
  const { mutate: deleteWorkspace } = useDeleteWorkspace({
    accessibleWorkspaces: accessibleWorkspaces?.workspaces || [],
  });
  const { mutate: updateWorkspace } = useUpdateWorkspace();
  const { mutate: setDefaultWorkspace } = useSetDefaultWorkspace();

  const [isChangeNameDialogOpen, setIsChangeNameDialogOpen] = useState(false);
  const [isAddMemberDialogOpen, setIsAddMemberDialogOpen] = useState(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState<Workspace | null>(null);

  const handleEditWorkspaceName = (workspace: Workspace) => {
    setSelectedWorkspace(workspace);
    setIsChangeNameDialogOpen(true);
  };

  const handleSaveWorkspaceName = () => {
    if (!selectedWorkspace) {
      return;
    }

    updateWorkspace({
      workspaceId: selectedWorkspace.id,
      name: selectedWorkspace.name,
    });

    setIsChangeNameDialogOpen(false);
  };
  const getFilteredWorkspaces = () => workspaces?.items ?? [];

  const handleAddMemberToWorkspace = (workspace: Workspace) => {
    setSelectedWorkspace(workspace);
    setIsAddMemberDialogOpen(true);
  };

  const handleSetDefaultWorkspace = (workspace: Workspace, organizationMemberId?: number) => {
    if (!organizationMemberId) {
      return;
    }

    setDefaultWorkspace({
      workspace_id: workspace.id,
      organization_member_id: organizationMemberId,
    });
  };

  return {
    accessibleWorkspaces,
    isChangeNameDialogOpen,
    setIsChangeNameDialogOpen,
    selectedWorkspace,
    setSelectedWorkspace,
    handleDeleteWorkspace: deleteWorkspace,
    handleEditWorkspaceName,
    handleSaveWorkspaceName,
    getFilteredWorkspaces,
    handleAddMemberToWorkspace,
    isAddMemberDialogOpen,
    setIsAddMemberDialogOpen,
    isLoadingWorkspaces,
    handleSetDefaultWorkspace,
  };
};
